'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutPropertiesLoose = require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
var faSpinnerThird = require('@fortawesome/pro-regular-svg-icons/faSpinnerThird');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var clsx = require('clsx');
var React = require('react');
var twMerge = require('../../tw-merge-2e22aa15.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["children", "className", "disabled", "loading", "onClick", "palette", "type", "variant"];
function Button(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      onClick = _ref.onClick,
      palette = _ref.palette,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      variant = _ref.variant,
      restButtonProps = _objectWithoutPropertiesLoose__default["default"](_ref, _excluded);

  return /*#__PURE__*/React__default["default"].createElement("button", _extends__default["default"]({
    className: twMerge.twMerge(clsx.clsx('relative px-4 py-2 text-sm font-bold uppercase', [variant === 'filled' && ['ml-0.5 border-2 border-transparent text-white outline outline-2 transition-colors focus:border-white', {
      'bg-primary-base outline-primary-base focus:bg-primary-dark focus:outline-primary-dark': palette === 'primary',
      'bg-secondary-base outline-secondary-base focus:bg-secondary-dark focus:outline-secondary-dark': palette === 'secondary',
      'bg-basic-dark outline-basic-dark focus:bg-basic-darker focus:outline-basic-darker': palette === 'muted',
      'bg-danger-base outline-danger-base focus:bg-danger-dark focus:outline-danger-dark': palette === 'danger'
    }, !disabled && !loading && {
      'hover:bg-primary-darker hover:outline-primary-dark hover:border-primary-darker': palette === 'primary',
      'hover:bg-secondary-dark hover:outline-secondary-dark hover:border-secondary-dark': palette === 'secondary',
      'hover:bg-basic-darker hover:outline-basic-darker hover:border-basic-darker': palette === 'muted',
      'hover:bg-danger-darker hover:outline-danger-dark hover:border-danger-darker': palette === 'danger'
    }, loading && {
      'outline-primary-base/50': palette === 'primary',
      'outline-secondary-base/50': palette === 'secondary',
      'outline-basic-dark/50': palette === 'muted',
      'outline-danger-base/50': palette === 'danger'
    }]], [variant === 'outlined' && ['ml-0.5 border-2 border-white bg-white outline outline-2 transition-colors focus:border-white focus:text-white', {
      'outline-primary-base text-primary-base  focus:bg-primary-dark  focus:outline-primary-dark': palette === 'primary',
      'outline-secondary-base text-secondary-base  focus:bg-secondary-dark  focus:outline-secondary-dark': palette === 'secondary',
      'outline-basic-dark text-basic-dark focus:bg-basic-dark  focus:outline-basic-dark': palette === 'muted',
      'outline-danger-base text-danger-base  focus:bg-danger-dark  focus:outline-danger-dark': palette === 'danger'
    }, !disabled && !loading && {
      'hover:bg-primary-base hover:border-primary-base hover:text-white': palette === 'primary',
      'hover:bg-secondary-base hover:border-secondary-base hover:text-white': palette === 'secondary',
      'hover:bg-basic-dark hover:border-basic-dark hover:text-white': palette === 'muted',
      'hover:bg-danger-base hover:border-danger-base hover:text-white': palette === 'danger'
    }]], [variant === 'ghost' && ['ml-0.5 border-2 border-transparent outline outline-2 outline-transparent transition-colors focus:border-white focus:outline-2', {
      'text-primary-base  hover:bg-primary-base hover:text-white focus:bg-white focus:outline-primary-dark focus:text-primary-base': palette === 'primary',
      'text-secondary-base  hover:bg-secondary-base hover:text-white focus:bg-white focus:outline-secondary-dark focus:text-secondary-base': palette === 'secondary',
      'text-danger-base  hover:bg-danger-base hover:text-white focus:bg-white focus:outline-danger-dark focus:text-danger-base': palette === 'danger',
      'text-success-base  hover:bg-success-base hover:text-white focus:bg-white focus:outline-success-dark focus:text-success-base': palette === 'success'
    }, !disabled && !loading && {
      'hover:bg-primary-base hover:border-primary-base hover:text-white': palette === 'primary',
      'hover:bg-secondary-base hover:border-secondary-base hover:text-white': palette === 'secondary',
      'hover:bg-danger-base hover:border-danger-base hover:text-white': palette === 'danger'
    }]], {
      'cursor-not-allowed opacity-70': disabled && !loading,
      'cursor-wait opacity-70': loading
    }), className),
    disabled: disabled || loading,
    onClick: onClick,
    type: type
  }, restButtonProps), loading && /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: faSpinnerThird.faSpinnerThird,
    "data-testid": "spinner",
    className: "pointer-events-none visible absolute inset-x-0 mx-auto animate-spin"
  }), loading ? /*#__PURE__*/React__default["default"].createElement("span", {
    "aria-hidden": loading,
    className: clsx.clsx({
      invisible: loading
    })
  }, children) : children);
}

exports.Button = Button;
